<template>
  <div>
    <PageAllow controller="OrderMaterialAnalyze" action="orderBacklog" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRange
              type="datetime"
              v-model="datetimeRage"
              :label="$t('OrderBacklog.Fields.not_order_number')"
              @changedModel="datetimeRageChanged = $event"
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn
              v-if="
                $permission.permissionAllow(
                  'OrderMaterialAnalyze',
                  'orderBacklogExport'
                )
              "
              small
              color="print"
              dark
              class="ms-1"
              @click.stop="OrderBacklogExportExcel()"
            >
              <v-icon x-small class="pe-1">fa-file-excel</v-icon>
              {{ $t("Export.excel") }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="shop_user_name "
                  v-model="options.shop_user_name"
                  @text="shopnameKeyword = $event"
                  :label="
                    $t('OrderBacklog.shopnameKeyword', [$consts.shopName()])
                  "
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherShops
                  v-model="shopsSelected"
                  :label="$t('OrderBacklog.shop', [$consts.shopName()])"
                />
              </v-col>
              <!-- 分组 -->
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-if="
                  settings && settings.report_hide_search_district_tree == 2
                "
              >
                <SearcherDistrictsWithDescendants
                  v-model="DistrictsSelected"
                  :label="
                    $t('shopDailyReports.shopDistricts', [$consts.shopName()])
                  "
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherAlliances
                  v-model="alliancesSelected"
                  :label="$t('OrderBacklog.alliance', [$consts.allianceName()])"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStatus
                  v-model="options.status"
                  :label="$t('OrderBacklog.status.title')"
                  :items="$consts.orderBacklogStatus"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="shops"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-2 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:item.total="{ item }">
            {{ $t("Global.money") }}{{ item.total | formatMoney }}
          </template>
          <template v-slot:item.num="{ item }">
            {{ item.num | formatTwoDot }}
          </template>
          <template v-slot:item.average_price="{ item }">
            {{ $t("Global.money") }}{{ item.average_price | formatMoney }}
          </template>
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import orderBacklog from "@/api/order_backlog";
import Consts from "@/consts.js";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherAlliances from "@/components/plugins/SearcherAlliances";
import SearcherDatetimeRange from "@/components/plugins/SearcherDatetimeRange";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";

const defaultOptions = {
  actual_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  actual_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  shop_id: [],
  status: [0, 1, 2, 3],
  shop_user_name: "", //客户用户名
  district_codes: [],
  alliance_business_ids: [],
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherShops,
    SearcherStatus,
    SearcherKeyword,
    SearcherAlliances,
    SearcherDatetimeRange,
    SearcherDistrictsWithDescendants,
  },

  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.orderBacklog"),
          disabled: true,
          href: "/order-backlog",
        },
      ];
    },

    headers() {
      return [
        {
          text: i18n.t("OrderBacklog.Fields.shop_code", [Consts.shopName()]),
          align: "start",
          sortable: false,
          value: "shop_code",
        },
        {
          text: i18n.t("OrderBacklog.Fields.shop_name", [Consts.shopName()]),
          align: "start",
          sortable: false,
          value: "shop_name",
        },
        {
          text: i18n.t("OrderBacklog.Fields.district_name"),
          align: "start",
          sortable: false,
          value: "district_name",
        },
        {
          text: i18n.t("OrderBacklog.Fields.shop_user_name"),
          align: "start",
          sortable: false,
          value: "shop_user_name",
        },
        {
          text: i18n.t("OrderBacklog.Fields.createdTime"),
          align: "start",
          width: "200px",
          sortable: false,
          value: "createdTime",
        },
      ];
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "districtID"]),
  },

  data: () => ({
    datetimeRage: [
      new Date(new Date().getTime() - 24 * 3600 * 1000)
        .toISOString()
        .substr(0, 10) + " 00:00:00",
      new Date(new Date().getTime() - 24 * 3600 * 1000)
        .toISOString()
        .substr(0, 10) + " 23:59:59",
    ],
    datetimeRageChanged: false,
    options: JSON.parse(JSON.stringify(defaultOptions)),
    shopKeyword: "",
    shopSelected: null,
    shops: [],
    paging: {},
    totalMoney: 0,
    totalOrderNum: 0,
    totalAverageMoney: 0,
    alliancesSelected: null,
    shopsSelected: null,
    DistrictsSelected: [],
  }),

  mounted() {
    this.$store.commit(
      "searchDistrict",
      this.settings && this.settings.report_hide_search_district_tree == 1
        ? true
        : false
    );
    this.$commonUtils
      .loadOptions("order_backlog", [
        "shopsSelected",
        "alliancesSelected",
        "DistrictsSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
            if (
              typeof this.options.actual_time_from != "undefined" &&
              typeof this.options.actual_time_to != "undefined"
            )
              this.datetimeRage = [
                this.options.actual_time_from,
                this.options.actual_time_to,
              ];
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
              case "alliancesSelected":
                this.alliancesSelected = selected.value;
                break;
              case "DistrictsSelected":
                this.DistrictsSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign(this.options, {
        shop_user_name: this.shopnameKeyword,
      });
      this.getOrderBacklogFromAPI();
    },
    resetSearch() {
      this.shopsSelected = [];
      this.alliancesSelected = [];
      this.DistrictsSelected = [];
      this.datetimeRage = [
        new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
          .toISOString()
          .substr(0, 10) + " 00:00:00",
        new Date().toISOString().substr(0, 10) + " 23:59:59",
      ];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getOrderBacklogFromAPI() {
      orderBacklog.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.shops = response.data.shops;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    OrderBacklogExportExcel() {
      orderBacklog.Exports(this.options);
    },
  },

  watch: {
    districtID: {
      handler() {
        if (
          this.settings &&
          this.settings.report_hide_search_district_tree == 1
        ) {
            this.options = Object.assign({}, this.options, {
              district_id: this.districtID,
            });
          // this.getOrderBacklogFromAPI();
        }
      },
    },
    options: {
      deep: true,
      handler() {
        this.getOrderBacklogFromAPI();
        sessionStorage.setItem(
          "order_backlog-options",
          JSON.stringify(this.options)
        );
      },
    },
    // 销售
    alliancesSelected: {
      handler() {
        this.options.alliance_business_ids = this.alliancesSelected
          ? this.alliancesSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "order_backlog-alliancesSelected",
          JSON.stringify(this.alliancesSelected)
        );
      },
    },
    // 门店
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected
          ? this.shopsSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "order_backlog-shopsSelected",
          JSON.stringify(this.shopsSelected)
        );
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage[0] == null || this.datetimeRage[0] == "") {
          this.options.actual_time_from =
            new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00";
        } else {
          this.options.actual_time_from = this.datetimeRage[0];
        }

        if (this.datetimeRage[1] == null || this.datetimeRage[1] == "") {
          this.options.actual_time_to =
            new Date().toISOString().substr(0, 10) + " 23:59:59";
        } else {
          this.options.actual_time_to = this.datetimeRage[1];
        }
      },
    },
    DistrictsSelected: {
      handler() {
        if (
          this.settings &&
          this.settings.report_hide_search_district_tree == 2)
        { 
          this.options.district_ids = this.DistrictsSelected
            ? this.DistrictsSelected.map((e) => {
              return e.id;
            })
            : [];
          sessionStorage.setItem(
            "order_backlog-DistrictsSelected",
            JSON.stringify(this.DistrictsSelected)
          );
        }
      },
    },
    settings: {
      handler() {
        this.$store.commit(
          "searchDistrict",
          this.settings && this.settings.report_hide_search_district_tree == 1
            ? true
            : false
        );
      },
    },
  },
};
</script>